import { createUseStyles } from 'react-jss';
import { Breakpoints } from '@/lib/breakpoints';

const useStyles = createUseStyles(
  {
    grid: { overflow: 'hidden', transition: 'opacity 200ms' },
    gridReady: { opacity: 1 },
    gridHidden: { opacity: 0 },
    link: { position: 'relative', textDecoration: 'none' },
    mediaWrap: { position: 'relative', width: '100%' },
    mediaInner: {
      transition: 'transform 300ms',
      [Breakpoints.SM]: { '.group:hover &': { transform: 'scale(1.1)' } },
    },
  },
  { name: 'category-grid' },
);

export default useStyles;
